export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_shops(state, data) {
    state.shops = data;
    state.totalCount = data.totalCount;
    state.count = data.count;
    state.loaded = true;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
